import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { isTokenValid } from '../../utils/Auth';
import { WishlistLine } from '../../interfaces/Wishlist/WishlistLine';
import { getWishlist } from '../../api/Wishlist';
import { bodyWidth } from '../../utils/Style';
import { WishlistItemPlaceholder } from './WishlistItemPlaceholder';
import { useIsMobile } from '../../hooks/useIsMobile';
import { WishlistTable } from './WishlistTable';
import { WishlistCard } from './WishlistCard';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';

export const WishlistPage = () => {
  const navigate = useNavigate();

  const isMobile = useIsMobile();

  const [lines, setLines] = useState<WishlistLine[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshWishlist = () => {
    setLoading(true);
    getWishlist()
      .then(setLines)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!isTokenValid()) {
      navigate('/giris-yap');
      return;
    }

    refreshWishlist();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Favorilerim' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <Typography sx={{ fontSize: '22px', fontWeight: 700 }}>
          Favoriler
        </Typography>

        {loading &&
          Array(5)
            .fill(null)
            .map((_, i) => <WishlistItemPlaceholder key={i} />)}

        {!loading && !lines.length && (
          <Typography>Favori listenizde henüz bir ürün bulunmuyor</Typography>
        )}

        {!!lines.length &&
          !loading &&
          (isMobile ? (
            lines.map((line) => (
              <WishlistCard
                key={line.productID}
                line={line}
                onRemove={refreshWishlist}
              />
            ))
          ) : (
            <WishlistTable lines={lines} onUpdate={refreshWishlist} />
          ))}
      </Box>
    </Box>
  );
};
